// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar-module--navbar--oU2BD","logo":"Navbar-module--logo--2pw3q","link":"Navbar-module--link--2PJlA"};